export type PendingPersonalChat = { id: string; chatId: string };

// Chats created outside the chat page, which shows them before they sync.
const handedOff: PendingPersonalChat[] = [];

export const handOffPendingPersonalChat = (chat: PendingPersonalChat) => {
  handedOff.push(chat);
};

export const handedOffPendingPersonalChats = (): PendingPersonalChat[] => [
  ...handedOff,
];

export const forgetHandedOffPersonalChats = (ids: readonly string[]) => {
  for (const id of ids) {
    const index = handedOff.findIndex((chat) => chat.id === id);
    if (index !== -1) handedOff.splice(index, 1);
  }
};
